import { Navigate, Route, Routes } from "react-router-dom"
import EntryRedirect from "@/components/EntryRedirect"
import RequireAuth from "@/components/RequireAuth"
import LoginPage from "@/pages/auth/LoginPage"
import VerifySmsPage from "@/pages/auth/VerifySmsPage"
import WelcomePage from "@/pages/WelcomePage"
import PlayProviders from "@/features/play/PlayProviders"
import PlayGate from "@/features/play/PlayGate"
import PlayLayout from "@/features/play/PlayLayout"
import BattleLobbyPage from "@/features/screens/BattleLobbyPage"
import GuardiansHomePage from "@/features/screens/GuardiansHomePage"
import HubPage from "@/features/screens/HubPage"
import MapTab from "@/features/play/tabs/MapTab"
import CollectionTab from "@/features/play/tabs/CollectionTab"
import ProfileTab from "@/features/play/tabs/ProfileTab"
import OnboardingWizard from "@/features/onboarding/OnboardingWizard"
import ShopPage from "@/features/screens/ShopPage"
import CardDetailPage from "@/features/screens/CardDetailPage"
import CityChatPage from "@/features/screens/CityChatPage"
import LocationScanPage from "@/features/screens/LocationScanPage"
import DailyQuestsPage from "@/features/screens/DailyQuestsPage"
import NotificationsPage from "@/features/screens/NotificationsPage"
import TrainingPage from "@/features/screens/TrainingPage"
import LeaderboardPage from "@/features/screens/LeaderboardPage"
import PastChampionsPage from "@/features/screens/PastChampionsPage"
import GuildPage from "@/features/screens/GuildPage"
import AcademyQuizPage from "@/features/screens/AcademyQuizPage"
import RedeemPage from "@/features/screens/RedeemPage"
import MatchmakingPage from "@/features/screens/MatchmakingPage"
import DuelPage from "@/features/screens/DuelPage"
import BossMapPage from "@/features/screens/BossMapPage"
import WorldBossPage from "@/features/screens/WorldBossPage"
import CardShopPage from "@/features/screens/CardShopPage"
import BankPage from "@/features/screens/BankPage"
import PostOfficePage from "@/features/screens/PostOfficePage"
import CityHallPage from "@/features/screens/CityHallPage"
import CityHallRaidPage from "@/features/screens/CityHallRaidPage"
import CityHallRaidBattlePage from "@/features/screens/CityHallRaidBattlePage"
import AirshipPage from "@/features/screens/AirshipPage"
import VirtualTournamentPage from "@/features/screens/VirtualTournamentPage"
import VirtualTournamentDetailPage from "@/features/screens/VirtualTournamentDetailPage"
import DailyTournamentPage from "@/features/screens/DailyTournamentPage"
import DailyTournamentDetailPage from "@/features/screens/DailyTournamentDetailPage"
import DeckBuilderPage from "@/features/screens/DeckBuilderPage"
import DeckDuelPage from "@/features/screens/DeckDuelPage"
import ShardsPage from "@/features/screens/ShardsPage"
import RulesPage from "@/features/screens/RulesPage"
import HelpPage from "@/features/screens/HelpPage"
import BaseMapPage from "@/features/screens/BaseMapPage"
import FeatureDataPage from "@/features/screens/FeatureDataPage"
import PublicProfilePage from "@/features/screens/PublicProfilePage"
import ReferralPage from "@/features/screens/ReferralPage"
import PetPage from "@/features/screens/PetPage"
import AlmanacPage from "@/features/screens/AlmanacPage"
import BattleHistoryPage from "@/features/screens/BattleHistoryPage"
import RankExamPage from "@/features/screens/RankExamPage"
import FuseCardsPage from "@/features/screens/FuseCardsPage"
import CardWardrobePage from "@/features/screens/CardWardrobePage"
import ArenaListPage from "@/features/screens/ArenaListPage"
import ArenaRoomPage from "@/features/screens/ArenaRoomPage"
import TreasurePage from "@/features/screens/TreasurePage"
import WiseTreePage from "@/features/screens/WiseTreePage"
import HotelPage from "@/features/screens/HotelPage"
import BoosterShopPage from "@/features/screens/BoosterShopPage"
import HangarPage from "@/features/screens/HangarPage"
import WarDashboardPage from "@/features/screens/WarDashboardPage"
import CityChroniclePage from "@/features/screens/CityChroniclePage"
import GameNotificationDetailPage from "@/features/screens/GameNotificationDetailPage"
import ChallengeWaitingPage from "@/features/screens/ChallengeWaitingPage"
import DeckChallengeWaitingPage from "@/features/screens/DeckChallengeWaitingPage"
import OnlinePlayersPage from "@/features/screens/OnlinePlayersPage"
import DeckMatchmakingPage from "@/features/screens/DeckMatchmakingPage"
import PostOfficeCreateLotPage from "@/features/screens/PostOfficeCreateLotPage"
import DustShopPage from "@/features/screens/DustShopPage"
import { getCards, getPassport } from "@/api/gameApi"

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<EntryRedirect />} />
      <Route path="/welcome" element={<WelcomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/verify" element={<VerifySmsPage />} />
      <Route
        path="/play"
        element={
          <RequireAuth>
            <PlayProviders>
              <PlayGate />
            </PlayProviders>
          </RequireAuth>
        }
      >
        <Route path="onboarding" element={<OnboardingWizard />} />
        <Route path="onboarding/affiliation" element={<OnboardingWizard />} />
        <Route path="onboarding/path" element={<OnboardingWizard />} />
        <Route path="onboarding/starter" element={<OnboardingWizard />} />
        <Route element={<PlayLayout />}>
          <Route index element={<GuardiansHomePage />} />
          <Route path="hub" element={<HubPage />} />
          <Route path="map" element={<MapTab />} />
          <Route path="collection" element={<CollectionTab />} />
          <Route path="profile" element={<ProfileTab />} />
        </Route>
        <Route path="matchmaking" element={<MatchmakingPage />} />
        <Route path="challenge-waiting" element={<ChallengeWaitingPage />} />
        <Route path="deck-challenge-waiting" element={<DeckChallengeWaitingPage />} />
        <Route path="online-players" element={<OnlinePlayersPage />} />
        <Route path="duel" element={<DuelPage />} />
        <Route path="deck-builder" element={<DeckBuilderPage />} />
        <Route path="deck-matchmaking" element={<DeckMatchmakingPage />} />
        <Route path="battle-lobby" element={<BattleLobbyPage />} />
        <Route path="deck-duel" element={<DeckDuelPage />} />
        <Route path="cards/:cardId" element={<CardDetailPage />} />
        <Route path="cards/:cardId/rank-exam" element={<RankExamPage />} />
        <Route path="fuse" element={<FuseCardsPage />} />
        <Route path="wardrobe" element={<CardWardrobePage />} />
        <Route path="shop" element={<ShopPage />} />
        <Route path="leaderboard" element={<LeaderboardPage />} />
        <Route path="past-champions" element={<PastChampionsPage />} />
        <Route path="academy" element={<AcademyQuizPage />} />
        <Route path="daily-quests" element={<DailyQuestsPage />} />
        <Route path="guild" element={<GuildPage />} />
        <Route path="city-chat" element={<CityChatPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="notifications/detail" element={<GameNotificationDetailPage />} />
        <Route path="virtual-tournament" element={<VirtualTournamentPage />} />
        <Route
          path="virtual-tournament/:tournamentId"
          element={<VirtualTournamentDetailPage />}
        />
        <Route path="daily-tournament" element={<DailyTournamentPage />} />
        <Route
          path="daily-tournament/:tournamentId"
          element={<DailyTournamentDetailPage />}
        />
        <Route path="world-boss" element={<WorldBossPage />} />
        <Route path="boss-map" element={<BossMapPage />} />
        <Route path="location-scan" element={<LocationScanPage />} />
        <Route path="airship" element={<AirshipPage />} />
        <Route path="bank" element={<BankPage />} />
        <Route path="post-office" element={<PostOfficePage />} />
        <Route path="post-office/create-lot" element={<PostOfficeCreateLotPage />} />
        <Route path="dust-shop" element={<DustShopPage />} />
        <Route path="card-shop" element={<CardShopPage />} />
        <Route path="city-hall" element={<CityHallPage />} />
        <Route path="city-hall/raid" element={<CityHallRaidPage />} />
        <Route path="city-hall/raid/:raidId" element={<CityHallRaidBattlePage />} />
        <Route path="base-map" element={<BaseMapPage />} />
        <Route path="training" element={<TrainingPage />} />
        <Route path="redeem" element={<RedeemPage />} />
        <Route path="shards" element={<ShardsPage />} />
        <Route path="rules" element={<RulesPage />} />
        <Route path="help" element={<HelpPage />} />
        <Route path="player/:code" element={<PublicProfilePage />} />
        <Route path="almanac" element={<AlmanacPage />} />
        <Route path="almanac/:code" element={<AlmanacPage />} />
        <Route path="referral" element={<ReferralPage />} />
        <Route path="pet" element={<PetPage />} />
        <Route path="battle-history" element={<BattleHistoryPage />} />
        <Route path="war" element={<WarDashboardPage />} />
        <Route path="city-chronicle" element={<CityChroniclePage />} />
        <Route path="arena" element={<ArenaListPage />} />
        <Route path="arena/:arenaId" element={<ArenaRoomPage />} />
        <Route path="treasure" element={<TreasurePage />} />
        <Route path="wise-tree" element={<WiseTreePage />} />
        <Route path="hotel" element={<HotelPage />} />
        <Route path="booster-shop" element={<BoosterShopPage />} />
        <Route path="hangar" element={<HangarPage />} />
        <Route
          path="collection-raw"
          element={<FeatureDataPage title="Карты (JSON)" queryKey="cards-raw" queryFn={getCards} />}
        />
        <Route
          path="passport-raw"
          element={<FeatureDataPage title="Паспорт" queryKey="passport-raw" queryFn={getPassport} />}
        />
      </Route>
      <Route path="*" element={<EntryRedirect />} />
    </Routes>
  )
}
